import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  DOCUMENT_DETAILS_GET,
  DOCUMENT_DETAILS_RESET,
  DOCUMENTS_CATEGORIES_GET,
  DOCUMENTS_LIST_GET,
} from '../actions/documents';

const initialState = {
  filters: {},
  list: [],
  details: {},
  pager: {},
  categories: [],
};

const userReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case DOCUMENTS_LIST_GET._SUCCESS: {
        const { response, pager } = action;
        draft.filters = { ...state.filters, ...(response?.filters || {}) };
        draft.list = response?.items || [];
        draft.pager = pager ?? {};
        break;
      }

      case DOCUMENT_DETAILS_GET._SUCCESS: {
        const { response = {} } = action;
        draft.details = { ...response };
        break;
      }

      case DOCUMENTS_CATEGORIES_GET._SUCCESS: {
        const { response = [] } = action;
        draft.categories = response;
        break;
      }

      case DOCUMENT_DETAILS_RESET: {
        draft.details = initialState.details;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default userReducer;
